/**
 * Get public environment variable value
 * Prioritizes runtime config from window object over build-time process.env
 * 
 * @param envKey - The environment variable key (e.g., 'NEXT_PUBLIC_STRAPI_API_URL')
 * @returns The environment variable value or empty string if not found
 */

// Extend Window interface to include our config
declare global {
  interface Window {
    __NEXT_PUBLIC_CONFIG__?: Record<string, string>;
  }
}

export function getPublicEnv(envKey: string): string | undefined {
  // Check if running in browser and runtime config is available
  if (typeof window !== "undefined" && window.__NEXT_PUBLIC_CONFIG__) {
    const value = window.__NEXT_PUBLIC_CONFIG__[envKey];
    return value || undefined;
  }
  // Fallback to process.env (build-time or server-side)
  return process.env[envKey] || undefined;
}
